module.exports = __webpack_public_path__ + "static/media/continuous-monitoring.97968253.png";